import { Box } from '@medely/ui-kit';
import React from 'react';
import { Experience } from './components/Experience';
import { Education } from './components/Education';
import { ElectronicHealthRecordsView } from '../ElectronicHealthRecords/ElectronicHealthRecordsView';

export const ResumeBuilder = () => {
  return (
    <Box py={4} bgColor="surface.paper">
      <Experience />
      <Education />
      <ElectronicHealthRecordsView />
    </Box>
  );
};
